import React from 'react'
import { Link } from 'react-router-dom'

function ListingBlog({ blogData }) {
  const getLimitedHtml = (html, wordLimit) => {
    // Remove HTML tags for counting words
    const textOnly = html.replace(/<[^>]+>/g, "");
    const words = textOnly.split(/\s+/);
    const limitedText = words.slice(0, wordLimit).join(" ");
    return limitedText + (words.length > wordLimit ? "..." : "");
  };
  return (
    <div className="ttm-row sidebar ttm-sidebar-right clearfix">
      <div className="container">
        {/* row */}
        <div className="row">
          <div className="col-lg-8 content-area">
            {blogData?.map((item) => {
              return (
                <article className="post ttm-blog-classic clearfix">
                  {/* post-featured-wrapper */}
                  <div className="ttm-post-featured-wrapper ttm-featured-wrapper">
                    <div className="ttm-post-featured">
                      <img className="img-fluid" src={item?.img} alt="blog-img" />
                      {/* <div className="ttm-box-post-date">
                <span className="ttm-entry-date">
                  <time className="entry-date" dateTime="2021-03-18T04:16:25+00:00">18<span className="entry-month entry-year">Mar</span></time>
                </span>
              </div> */}
                    </div>
                  </div>{/* post-featured-wrapper end */}
                  {/* ttm-blog-classic-content */}
                  <div className="ttm-blog-classic-content">
                    <div className="ttm-post-entry-header">
                      <div className="post-meta">
                        <span className="ttm-meta-line category"><i className="ti ti-folder" />Textile World</span>
                      </div>
                      <header className="entry-header">
                        <h1 className="entry-title"><Link to={`/${item?.title
                          ?.toLowerCase()
                          .replace(/[^a-z0-9\s]/g, "") // remove special chars
                          .trim()
                          .replace(/\s+/g, "-")}`}     // replace spaces with '-'
                        >{item?.title}</Link></h1>
                      </header>
                    </div>
                    <div className="entry-content">
                      <div className="ttm-box-desc-text">
                        <div dangerouslySetInnerHTML={{ __html: getLimitedHtml(item.description, 50) }} /></div>
                      <div className="ttm-blogbox-footer-readmore">
                        <Link className="ttm-btn ttm-btn-size-md ttm-btn-color-dark btn-inline ttm-icon-btn-right" to={`/${item?.title
                          ?.toLowerCase()
                          .replace(/[^a-z0-9\s]/g, "") // remove special chars
                          .trim()
                          .replace(/\s+/g, "-")}`}     // replace spaces with '-'
                        >read more<i className="fa fa-long-arrow-right" /></Link>
                      </div>
                    </div>
                  </div>{/* ttm-blog-classic-content end */}
                </article>
              )
            })}

            {/* <div className="pagination-block">
          <span className="page-numbers current">1</span>
          <a className="page-numbers" href="#">2</a>
          <a className="next page-numbers" href="#"><i className="fa fa-long-arrow-right" /></a>
        </div> */}
          </div>
          <div className="col-lg-4 widget-area sidebar-right">
            <aside className="widget widget-search with-title">
              <h3 className="widget-title">Search</h3>
              <form role="search" method="get" className="search-form" action="#">
                <label>
                  <span className="screen-reader-text">Search for:</span>
                  <input type="search" className="input-text" placeholder="Search …" name="s" />
                </label>
                <button className="btn" type="submit"><i className="fa fa-search" /> </button>
              </form>
            </aside>
            <aside className="widget widget-Categories with-title">
              <h3 className="widget-title">Categories</h3>
              <ul>
                <li><a href="#">Fashion &amp; Retail</a><span>1</span></li>
                <li><a href="#">Industry Insight</a><span>1</span></li>
                <li><a href="#">News &amp; Analysis</a><span>1</span></li>
                <li><a href="#">Textile World</a><span>1</span></li>
                <li><a href="#">Trade &amp; Business</a><span>1</span></li>
                <li><a href="#">Traditional</a><span>1</span></li>
              </ul>
            </aside>
            <aside className="widget widget-recent-post with-title">
              <h3 className="widget-title">Recent Posts</h3>
              <ul className="widget-post ttm-recent-post-list">
                <li>
                  <Link to={"/blog-single"}><img className="img-fluid" src="images/blog/b_thumbb-01.jpg" alt="post-img" /></Link>
                  <div className="post-detail">
                    <Link to={"/blog-single"}>Can textiles lead the way during the pandemic?</Link>
                    <span className="post-date"><i className="fa fa-calendar" />March 18, 2021</span>
                  </div>
                </li>
                <li>
                  <Link to={"/blog-single"}><img className="img-fluid" src="images/blog/b_thumbb-02.jpg" alt="post-img" /></Link>
                  <div className="post-detail">
                    <Link to={"/blog-single"}>One stop solution for textiles fabrics</Link>
                    <span className="post-date"><i className="fa fa-calendar" />February 28, 2021</span>
                  </div>
                </li>
                <li>
                  <Link to={"/blog-single"}><img className="img-fluid" src="images/blog/b_thumbb-03.jpg" alt="post-img" /></Link>
                  <div className="post-detail">
                    <Link to={"/blog-single"}>Textilegence Magazine &amp; Digital Platform</Link>
                    <span className="post-date"><i className="fa fa-calendar" />February 15, 2021</span>
                  </div>
                </li>
              </ul>
            </aside>
            <aside className="widget tagcloud-widget with-title">
              <h3 className="widget-title">Popular Tags</h3>
              <div className="tagcloud">
                <a href="#" className="tag-cloud-link">Clothing</a>
                <a href="#" className="tag-cloud-link">Cotton</a>
                <a href="#" className="tag-cloud-link">Designer</a>
                <a href="#" className="tag-cloud-link">Embroidery</a>
                <a href="#" className="tag-cloud-link">Fabric</a>
                <a href="#" className="tag-cloud-link">Fashion</a>
                <a href="#" className="tag-cloud-link">Rayon</a>
                <a href="#" className="tag-cloud-link">Silk</a>
                <a href="#" className="tag-cloud-link">Textile</a>
              </div>
            </aside>
            <aside className="widget widget-banner">
              <div className="ttm-col-bgcolor-yes ttm-bgcolor-darkgrey col-bg-img-seven ttm-col-bgimage-yes ttm-bg">
                <div className="ttm-col-wrapper-bg-layer ttm-bg-layer">
                  <div className="ttm-col-wrapper-bg-layer-inner" />
                </div>
                <div className="layer-content">
                  <div className="widget-banner-inner">
                    <h3 className="ttm-textcolor-skincolor">Have Questions?</h3>
                    <p>Our Client Care Managers Are On Call 24/7 To Answer Your Question.</p>
                    <ul>
                      <li><i className="flaticon flaticon-phone-call" />+92 305 1115508</li>
                    </ul>
                  </div>
                </div>
              </div>
            </aside>
          </div>
        </div>{/* row end */}
      </div>
    </div>

  )
}

export default ListingBlog